import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.less'],
  standalone: false
})
export class LogoComponent implements OnInit {

  @Input() width = 200;

  constructor() { }

  ngOnInit() {
  }

}
